module.exports = __webpack_public_path__ + "static/tres_coracoes-76ca3cf6fdf63aa9a47dd786b79c2d60.png";